import { render } from "./MealTable.vue?vue&type=template&id=9b7f1798&scoped=true"
import script from "./MealTable.vue?vue&type=script&lang=js"
export * from "./MealTable.vue?vue&type=script&lang=js"

import "./MealTable.vue?vue&type=style&index=0&id=9b7f1798&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b7f1798"]])

export default __exports__